import React from 'react';
import { Form, Alert, Badge } from 'react-bootstrap';

const DatasetViewerFilterPanel = ({
  showFilterPanel,
  filter,
  setFilter,
  setFilterErr,
  computedFilterErr,
  colFilters,
  columns,
  clearColFilter,
  columnFilterLabel,
  filterActive,
  shown
}) => {
  if (!showFilterPanel) return null;

  return (
    <div className="p-2 border-bottom bg-light">
      <div className="d-flex flex-wrap align-items-center gap-2">
        <Form.Label className="fw-semibold m-0">Filter:</Form.Label>
        <Form.Control
          type="text"
          style={{ flex: '1', minWidth: '260px' }}
          placeholder="Type to filter rows..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') setFilter(filter.trim()); }}
        />
        <button className="updateProfile" type="button" onClick={() => setFilter(filter.trim())}>Apply</button>
        <button className="removeProfile" type="button" onClick={() => { setFilter(''); setFilterErr(''); }}>Clear</button>
      </div>
      <div className="text-muted small mt-1">
        {`Operators: == != > < >= <= — combine with and / or, group with ( ). Quote text with spaces, e.g. EVENTLABEL == "Screening Visit"; FIELD == "" tests for blank. Text without an operator searches all visible columns. Or use a column's ▾ menu for contains / equals / blank / range filters.`}
      </div>
      {computedFilterErr && <Alert variant="danger" className="mt-1 mb-0 py-1">{computedFilterErr}</Alert>}
      {Object.entries(colFilters).filter(([k]) => columns[+k] !== undefined).map(([k, f]) => {
        const col = columns[+k];
        return (
          <Badge key={k} bg="success-subtle" className="me-1 mt-1 text-success">
            {col} {columnFilterLabel(f)}
            <span className="ms-1 CP" title="Remove Filter" onClick={() => clearColFilter(+k)}>✕</span>
          </Badge>
        );
      })}
      {filterActive && shown === 0 && <Alert variant="warning" className="mt-1 mb-0 py-1">WARNING: filter returned zero records.</Alert>}
    </div>
  );
};

export default DatasetViewerFilterPanel;
